import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',

    '& > :first-child': {
      minWidth: '4rem',
      width: '4rem'
    },

    '&:not(:last-child)': {
      marginBottom: '1rem'
    }
  },

  role: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem'
  },

  email: {
    width: '100%',
    color: theme.palette.textAlt
  },

  switch: {
    marginLeft: '0.75rem'
  },

  button: {
    width: 'fit-content',
    paddingBlock: 0,
    fontSize: theme.size.sm
  }
}))

export default useStyles
